import React from "react";
import "./bodyWrapper.css";

const BodyWrapper = ({ children }) => {
  return <div className="bodyWrapper">{children}</div>;
};

export default BodyWrapper;
